import { Button, FormGroup, Input, Label } from 'reactstrap';
import { Field, Form, Formik } from 'formik';
import UnitToggle from '../UnitToggle';
import { useUnitContext } from '../../contexts/UnitContext';
import useMutateWithState from '../../hooks/useMutateWithState';

const UserForm = ({
  mutation,
  showLabels = false,
  initialValues,
  submitButtonText,
  successMessage,
  showSuperadmin = true,
}) => {
  const [{ loading }, mutateAndSetState] = useMutateWithState();

  const isUpdating = initialValues.id;
  const { setUnits } = useUnitContext();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={async (values) =>
        mutateAndSetState(
          () =>
            mutation({
              variables: {
                input: {
                  ...values,
                  __typename: undefined,
                },
              },
            }),
          successMessage,
        )
      }
    >
      {({ isSubmitting, setFieldValue, values }) => (
        <Form>
          {!isUpdating && (
            <FormGroup>
              {showLabels && <Label>Email</Label>}
              <Input
                tag={Field}
                type="email"
                name="email"
                placeholder="Email"
              />
            </FormGroup>
          )}
          {isUpdating && (
            <>
              <FormGroup>
                {showLabels && <Label>First Name</Label>}
                <Input
                  tag={Field}
                  type="text"
                  name="firstName"
                  placeholder="First name"
                />
              </FormGroup>
              <FormGroup>
                {showLabels && <Label>Last Name</Label>}
                <Input
                  tag={Field}
                  type="text"
                  name="lastName"
                  placeholder="Last name"
                />
              </FormGroup>
              <FormGroup>
                <Label>Default Unit System</Label>
                <div>
                  <UnitToggle
                    onChange={(value) => {
                      setFieldValue('defaultUnitSystem', value);
                      // Also update the context value to match
                      setUnits(value);
                    }}
                    value={values.defaultUnitSystem}
                  />
                </div>
              </FormGroup>
            </>
          )}
          {showSuperadmin && (
            <FormGroup check className="mb-3">
              <Label check>
                <Input tag={Field} name="superadminRole" type="checkbox" />{' '}
                Superadmin
              </Label>
            </FormGroup>
          )}
          <Button
            color="primary"
            type="submit"
            block
            disabled={isSubmitting || loading}
          >
            {submitButtonText}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default UserForm;
